/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { Button, Group, Modal, Select, TextInput } from "@mantine/core";
import { GraphQLSubscription, generateClient } from "aws-amplify/api";
import { updateCase } from "@/graphql/mutations";
import {
  UpdateCaseInput,
  UpdateCaseMutation,
  UpdateCaseMutationVariables,
} from "@/API";

const client = generateClient();

type editPatientProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  setModalConfirmDeleteOpened: (value: boolean) => void;
  patientCase: any;
  setPatientCase: (value: any) => void;
  fetchCases: () => void;
  templates: any;
};

const EditCaseModal = (props: editPatientProps) => {
  const {
    modalOpened,
    setModalOpened,
    patientCase,
    setPatientCase,
    setModalConfirmDeleteOpened,
    templates,
  } = props;
  const [loading, setLoading] = useState(false);
  const [templateData, setTemplateData] = useState<any>(templates);

  useEffect(() => {
    let data: any = templates;
    if (data?.length > 0) {
      data = data.map((item: any) => {
        return { value: item.id, label: item.name };
      });
    }
    setTemplateData(data);
  }, [templates]);

  const handleEditCase = async () => {
    try {
      setLoading(true);
      const { title, description } = patientCase;
      let updatedCaseInput: UpdateCaseInput = {
        id: patientCase.id,
        _version: patientCase._version,
        caseTemplateId: patientCase.caseTemplateId,
      };
      if (title !== "") {
        updatedCaseInput = { ...updatedCaseInput, title };
      }
      if (description !== "") {
        updatedCaseInput = {
          ...updatedCaseInput,
          description,
        };
      }
      const updatedCaseVars: UpdateCaseMutationVariables = {
        input: updatedCaseInput,
      };

      const updateCaseResult = await client.graphql<
        GraphQLSubscription<UpdateCaseMutation>
      >({ query: updateCase, variables: updatedCaseVars });
      console.log(updateCaseResult);
    } catch (err) {
      console.log("error editing case:", err);
    }
    setLoading(false);
    setModalOpened(false);
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={() => setModalOpened(false)}
      title="Edit case"
    >
      <TextInput
        label="Case title"
        placeholder="Enter case title"
        mb={16}
        value={patientCase?.title}
        onChange={(event) =>
          setPatientCase((oldState: any) => {
            return {
              ...oldState,
              title: event.target.value,
            };
          })
        }
      />
      <TextInput
        label="Case description"
        placeholder="Enter case description"
        mb={16}
        value={patientCase?.description}
        onChange={(event) =>
          setPatientCase((oldState: any) => {
            return {
              ...oldState,
              description: event.target.value,
            };
          })
        }
      />

      {templateData.length > 0 && patientCase?.caseTemplateId && (
        <Select
          placeholder="Select template"
          label="Template"
          data={templateData}
          value={patientCase?.caseTemplateId}
          onChange={(value) =>
            setPatientCase((oldState: any) => {
              return {
                ...oldState,
                caseTemplateId: value,
              };
            })
          }
        />
      )}

      <Group mt="md">
        <Group mt="md">
          <Button onClick={handleEditCase} loading={loading}>
            Save
          </Button>
          <Button
            color="red"
            onClick={() => {
              setModalOpened(false);
              setModalConfirmDeleteOpened(true);
            }}
          >
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default EditCaseModal;
